import React from 'react';
import Picker from 'react-mobile-picker';
import {
  MobileContainer,
  MobileTopRow,
  MobileLabel,
  PickerValue,
  StyledPickerWrapper,
  DropdownArrow,
} from './styles';

const NumericControl = ({
  pointId,
  currentValue,
  symbol,
  config,
  label,
  isEditable,
  handleValueChange,
  activePickerId,
  handleNumericClick,
}) => {
  const { customEnum } = config;
  const step = customEnum?.step ? parseFloat(customEnum.step) : 1;
  const min = customEnum?.min ? parseFloat(customEnum.min) : 0;
  const max = customEnum?.max ? parseFloat(customEnum.max) : 100;
  const currentVal =
    currentValue !== null && currentValue !== undefined ? parseFloat(currentValue) : null;

  const renderMobilePicker = () => {
    const val = currentVal !== null && currentVal !== undefined ? currentVal : min;

    const values = [];
    for (let i = min; i <= max; i += step) {
      values.push(`${i}${symbol ? ' ' + symbol : ''}`);
    }

    const closestValue =
      values.find((v) => parseFloat(v) === val) ||
      values.reduce((prev, curr) =>
        Math.abs(parseFloat(curr) - val) < Math.abs(parseFloat(prev) - val) ? curr : prev
      );

    return (
      <StyledPickerWrapper>
        <Picker
          optionGroups={{ value: values }}
          valueGroups={{ value: closestValue }}
          onChange={(name, displayValue) => {
            handleValueChange(pointId, parseFloat(displayValue.split(' ')[0]));
          }}
          wheel="normal"
          height={150}
          itemHeight={30}
        />
      </StyledPickerWrapper>
    );
  };

  const displayValue =
    currentVal !== null && !isNaN(currentVal)
      ? Number.isInteger(currentVal) ? currentVal : currentVal.toFixed(1)
      : '--';

  return (
    <MobileContainer key={pointId} isEditable={isEditable}>
      <MobileTopRow>
        <MobileLabel>{label}</MobileLabel>
        <PickerValue
          isEditable={isEditable}
          onClick={(e) => isEditable && handleNumericClick(pointId, e)}
        >
          {displayValue} {symbol}
          <DropdownArrow />
        </PickerValue>
      </MobileTopRow>
      {activePickerId === pointId && isEditable && renderMobilePicker()}
    </MobileContainer>
  );
};

export default NumericControl;
